const selectors = {
  copyClipboard: '[data-copy-clipboard]',
};

const sections = {};

class CopyClipboard {
  constructor(section) {
    this.container = section.container;
    this.copyButton = this.container.querySelector(selectors.copyClipboard);

    if (this.copyButton) {
      this.init();
    }
  }

  init() {
    this.copyButton.addEventListener('click', function (e) {
      e.preventDefault();
      const copyText = this.getAttribute('href');
      let inputElem = document.createElement('input');
      inputElem.type = 'text';
      this.appendChild(inputElem);
      const newInput = this.querySelector('input');
      newInput.value = copyText;
      newInput.select();
      newInput.setSelectionRange(0, 99999); /* For mobile devices */
      document.execCommand('copy');
      this.removeChild(newInput);
    });
  }
}

const copyClipboard = {
  onLoad() {
    sections[this.id] = new CopyClipboard(this);
  },
};

export default copyClipboard;
